import { render, staticRenderFns } from "./WhatsAppMessageTemplatePreview.vue?vue&type=template&id=aa0b8398&scoped=true&"
import script from "./WhatsAppMessageTemplatePreview.vue?vue&type=script&lang=js&"
export * from "./WhatsAppMessageTemplatePreview.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppMessageTemplatePreview.vue?vue&type=style&index=0&id=aa0b8398&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0b8398",
  null
  
)

export default component.exports